import { css } from 'styled-components';

const InputHourIndicator = css`
  right: 15px;
  &::after {
    border-style: solid;
    border-width: 0 3px 3px 0;
    content: '';
    display: inline-block;
    padding: 5px;
    transition: 0.3s;
    color: #657480;
    border-radius: 1px;
    transform-origin: center center;
  }
`;

export default InputHourIndicator;
